import React from "react";
import {useAppStore} from "../../common/app.store.consumer";
import {AppStore} from "../../stores/app.store";
import {TaxonomySelect} from "./types/questionnaire.autofill.dictate.taxonomy.select";
import {SelectOption} from "./types/questionnaire.autofill.dictate.select.option";

interface Props {
	appStore?: AppStore;
	title: string;
	numberOfQuestions: number;
	onChange: (selectedOption: TaxonomySelect) => void;
}

interface AutoFillDictateSelectState {
	selectOptions: SelectOption[];
	defaultOption: SelectOption;
}

@useAppStore()
export default class AutoFillDictateSelect extends React.Component<Props, AutoFillDictateSelectState> {
	constructor(props) {
		super(props);
		this.state = {
			selectOptions: [],
			defaultOption: {} as SelectOption,
		};
	}

	componentDidMount() {
		const selectOptions: SelectOption[] = [];
		for (let i = this.props.numberOfQuestions; i >= 0; i--) {
			selectOptions.push({key: i, value: `${i} / ${this.props.numberOfQuestions}`});
		}
		this.setState(
			{
				defaultOption: selectOptions[0],
				selectOptions: selectOptions,
			},
			() => {
				this.onOptionSelected();
			},
		);
	}
	onOptionSelected = async (e: React.ChangeEvent<HTMLSelectElement> = null) => {
		let selectedOption: SelectOption;
		if (e === null) {
			selectedOption = this.state.defaultOption;
		} else {
			selectedOption = this.state.selectOptions.find((selectOption) => selectOption.key.toString() === e.target.value);
		}
		this.props.onChange({taxonomyName: this.props.title, numberOfCorrectAnswers: selectedOption.key});
	};

	render() {
		if (!this?.state?.defaultOption) {
			return null;
		}
		return (
			<div className="cih-dictate-dropdown">
				<label>{this.props.title}</label>
				<select className="cih-select tmp-element" onChange={this.onOptionSelected} defaultValue={this.state.defaultOption.value}>
					{this.state.selectOptions.map((option) => (
						<option value={option.key} key={option.key}>
							{option.value}
						</option>
					))}
				</select>
			</div>
		);
	}
}
